// extracted by mini-css-extract-plugin
export default {"card":"styles_card__isury","header":"styles_header__8G+52","headerLeft":"styles_headerLeft__03Qy1","content":"styles_content__ET30D","row":"styles_row__Ao4Rq"};